var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { CustomScrollbarsScrollbar, CustomScrollbarsTrackAndThumb, CustomScrollbarsTrack, CustomScrollbarsThumb } from './scrollbar.styles';
export var ScrollbarTrackAndThumb = function (_a) {
    var direction = _a.direction, contentRef = _a.contentRef, scrollTrackRef = _a.scrollTrackRef, thumbWidth = _a.thumbWidth, thumbHeight = _a.thumbHeight, isDraggingScrollbar = _a.isDraggingScrollbar, scrollThumbRef = _a.scrollThumbRef, setScrollStartPosition = _a.setScrollStartPosition, setInitialScrollValue = _a.setInitialScrollValue, setIsDraggingScrollbar = _a.setIsDraggingScrollbar;
    var handleScrollButton = useCallback(function (direc) {
        var current = contentRef.current;
        if (current) {
            var scrollAmount = direc === 'bottom' ? 200 : -200;
            if (direction === 'horizontal') {
                current.scrollBy({ behavior: 'smooth', left: scrollAmount });
            }
            else {
                current.scrollBy({ behavior: 'smooth', top: scrollAmount });
            }
        }
    }, [contentRef]);
    var handleTrackClick = useCallback(function (e) {
        e.preventDefault();
        e.stopPropagation();
        var trackCurrent = scrollTrackRef.current;
        var contentCurrent = contentRef.current;
        if (trackCurrent && contentCurrent) {
            var clientY = e.clientY, clientX = e.clientX;
            var target = e.target;
            var rect = target.getBoundingClientRect();
            var trackTop = rect.top;
            var trackLeft = rect.left;
            var thumbOffsetY = -(thumbHeight / 2);
            var thumbOffsetX = -(thumbWidth / 2);
            var clickRatio = void 0;
            var scrollAmount = void 0;
            if (direction === 'vertical') {
                clickRatio = (clientY - trackTop + thumbOffsetY) / trackCurrent.clientHeight;
                scrollAmount = Math.floor(clickRatio * contentCurrent.scrollHeight);
                contentCurrent.scrollTo({
                    behavior: 'smooth',
                    top: scrollAmount,
                });
            }
            else {
                clickRatio = (clientX - trackLeft + thumbOffsetX) / trackCurrent.clientWidth;
                scrollAmount = Math.floor(clickRatio * contentCurrent.scrollWidth);
                contentCurrent.scrollTo({
                    behavior: 'smooth',
                    left: scrollAmount,
                });
            }
        }
    }, [thumbWidth, thumbHeight, contentRef, scrollTrackRef, direction]);
    var handleThumbMousedown = useCallback(function (e) {
        e.preventDefault();
        e.stopPropagation();
        setScrollStartPosition(direction === 'vertical' ? e.clientY : e.clientX);
        if (contentRef.current) {
            setInitialScrollValue(contentRef.current.scrollTop);
        }
        setIsDraggingScrollbar(true);
    }, [contentRef, setScrollStartPosition, setInitialScrollValue, setIsDraggingScrollbar, direction]);
    return (_jsxs(CustomScrollbarsScrollbar, __assign({ "$direction": direction }, { children: [_jsx("button", { onClick: function () { return handleScrollButton('top'); } }), _jsxs(CustomScrollbarsTrackAndThumb, __assign({ "$direction": direction }, { children: [_jsx(CustomScrollbarsTrack, { "$direction": direction, ref: scrollTrackRef, onClick: handleTrackClick, style: { cursor: isDraggingScrollbar ? 'grabbing' : undefined } }), _jsx(CustomScrollbarsThumb, { ref: scrollThumbRef, onMouseDown: handleThumbMousedown, "$direction": direction, style: {
                            cursor: isDraggingScrollbar ? 'grabbing' : 'grab',
                            height: direction === 'vertical' ? "".concat(thumbHeight, "px") : undefined,
                            width: direction === 'horizontal' ? "".concat(thumbWidth, "px") : undefined,
                        } })] })), _jsx("button", { onClick: function () { return handleScrollButton('bottom'); } })] })));
};
